import { jsx as _jsx } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import styles from './settings-placeholder.css';
export function SettingPlaceholder({ title }) {
    return (_jsx("div", { className: styles.bodyContainer, children: _jsx(Text, { info: true, children: title }) }));
}
